import {
    RtlsPlayerOptions,
    SiteRtlsPlayer,
} from '@myrtls/api-interfaces';
import { Action, createReducer, on } from '@ngrx/store';
import {
    getPlayerOptionsSuccessAction,
    getSitePlayerSuccessAction,
    initializeSitePlayerSuccessAction,
    updateSitePlayerSuccessAction,
} from './player.actions';
import { selectSiteAction } from '../sites/sites.actions';

export interface PlayerState {
    player: SiteRtlsPlayer | null;
    playerOptions: RtlsPlayerOptions | null;
}

const initialState: PlayerState = {
    player: null,
    playerOptions: null,
};

const reducer = createReducer(
    initialState,
    on(selectSiteAction, () => initialState),
    on(getSitePlayerSuccessAction, (state, { player }) => ({
        ...state,
        player,
    })),
    on(initializeSitePlayerSuccessAction, (state, { player }) => ({
        ...state,
        player,
    })),
    on(updateSitePlayerSuccessAction, (state, { player }) => ({
        ...state,
        player,
    })),
    on(getPlayerOptionsSuccessAction, (state, { options }) => ({
        ...state,
        playerOptions: options,
    })),
);

export function playerReducer(
    state: PlayerState | undefined,
    action: Action,
): PlayerState {
    return reducer(state, action);
}
